import i18n from '@/i18n';

// Backend errors carry a stable machine-readable `code` (plus optional
// `params`); the `message` they also carry is English developer text, so it is
// deliberately never shown. We translate the code when the catalogs know it and
// otherwise fall back to the caller's own generic key -- never a raw key and
// never English prose.

const descriptorText = (descriptor) => {
  if (descriptor.key && i18n.te(descriptor.key)) {
    return i18n.t(descriptor.key, descriptor.params || {});
  }
  // Unmapped AJV keywords ("should be string") still arrive as plain messages.
  return descriptor.message || '';
};

// `details` maps a field name to an array of descriptors. Field names are
// schema keys, so they stay untranslated.
const translateDetails = (details) =>
  Object.entries(details)
    .filter(([field]) => field && field !== '_id')
    .map(([field, descriptors]) => {
      const text = (descriptors || []).map(descriptorText).filter(Boolean).join(', ');
      return text ? `${field}: ${text}` : field;
    })
    .filter(Boolean)
    .join('; ');

export function translateApiError(error, fallbackKey, fallbackParams = {}) {
  const data = (error && error.response && error.response.data) || {};
  const key = data.code ? `errors.api.${data.code}` : null;

  if (key && i18n.te(key)) {
    const params = { ...(data.params || {}) };

    if (data.details) {
      params.errors = translateDetails(data.details);
    }

    return i18n.t(key, params);
  }

  return i18n.t(fallbackKey, fallbackParams);
}

export default translateApiError;
